<template>
  <div>
    <div v-if="isLoading && !data">
      Chargement des données ...
    </div>
    <div v-else>
      <h1 class="text-h1 font-weight-thin mb-3">
        Edition {{ data.edition }}
      </h1>
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr>
              <td>Nombre total de classes</td>
              <td>{{ data.nbClasses }}</td>
            </tr>
            <tr>
              <td>Nombre total d'élèves</td>
              <td>{{ data.nbStudentsAll }}</td>
            </tr>
            <tr>
              <td>Nombre d'élèves pour le Singulis</td>
              <td>{{ data.nbStudentsSingulis }}</td>
            </tr>
            <tr>
              <td>Nombre d'élèves pour l'Omnibus</td>
              <td>{{ data.nbStudentsOmnibus }}</td>
            </tr>
            <tr v-if="data.counterSingulis">
              <td>Nombre de classes pour le Singulis</td>
              <td>
                {{ data.counterSingulis.total }}
                <span style="color:#777">({{ data.counterSingulis.nbUploaded }})</span>
              </td>
            </tr>
            <tr v-if="data.counterOmnibus">
              <td>Nombre de classes pour l'Omnibus'</td>
              <td>
                {{ data.counterOmnibus.total }}
                <span style="color:#777">({{ data.counterOmnibus.nbUploaded }})</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <br>

      <v-data-table
        :headers="filtered"
        :items="participants"
        :items-per-page="300"
        class="elevation-3"
      >
        <template v-slot:top>
          <div class="d-flex justify-space-between align-center pa-4">
            <div style="max-width:300px">
              <v-text-field
                v-model="search"
                label="Rechercher"
                style="width:400px"
              />
            </div>
            <v-btn
              v-if="tableView != 'bill'"
              outlined
              small
              color="success"
              @click="tableView = 'bill'"
            >
              <v-icon
                class="mr-4"
                small
              >
                mdi-repeat
              </v-icon> Vue Classe
            </v-btn>
            <v-btn
              v-if="tableView === 'bill'"
              outlined
              small
              color="warning"
              @click="tableView = 'class'"
            >
              <v-icon
                class="mr-4"
                small
              >
                mdi-repeat
              </v-icon> Vue Trésorier
            </v-btn>
          </div>
        </template>

        <template v-slot:item.participant="{ item }">
          <div class="d-flex flex-column">
            <div class="font-weight-regular">
              {{ item.participant.fullName }}
            </div>
            <div class="text-caption">
              {{ item.user.email }}
            </div>
          </div>
        </template>

        <template v-slot:item.schoolName="{ item }">
          <div class="d-flex flex-column">
            <div>{{ item.participant.school.name }}</div>
            <div class="text-caption">
              {{ item.participant.school.fullAcademy }}
            </div>
          </div>
        </template>

        <template v-slot:item.nbClasses="{ item }">
          <div class="d-flex flex-column">
            <div>{{ item.classes.length }}</div>
          </div>
        </template>

        <template v-slot:item.nbStudents="{ item }">
          <div class="d-flex flex-column">
            <div>{{ item.nbStudents }}</div>
          </div>
        </template>

        <template v-slot:item.singulis="{ item }">
          <div class="">
            <chip-singulis
              v-for="one in item.classes.filter(one => one.doSingulis)"
              :key="one.id"
              :data="one"
              class="m-2"
            />
            <span v-if="!item.classes.filter(one => one.doSingulis).length">---</span>
          </div>
        </template>

        <template v-slot:item.omnibus="{ item }">
          <div class="">
            <chip-omnibus
              v-for="one in item.classes.filter(one => one.doOmnibus)"
              :key="one.id"
              :data="one"
              class="m-2"
            />
            <span v-if="!item.classes.filter(one => one.doOmnibus).length">---</span>
          </div>
        </template>

        <template v-slot:item.hasPaid="{ item }">
          <div>
            <v-btn
              small
              icon
              @click="editHasPaid(item)"
            >
              <v-icon
                v-if="item.hasPaid"
                color="success"
                small
              >
                mdi-checkbox-marked-circle
              </v-icon>
              <v-icon
                v-else
                small
              >
                mdi-checkbox-blank-circle-outline
              </v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:item.paymentMode="{ item }">
          <v-btn
            small
            text
            @click="editPaymentMode(item)"
          >
            {{ item.paymentMode }}
          </v-btn>
        </template>

        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  v-bind="attrs"
                  @click="editComment(item)"
                  v-on="on"
                >
                  <v-icon small>
                    mdi-bookmark-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>Ajouter un memento</span>
            </v-tooltip>
            <v-btn
              small
              icon
              disabled
              @click="editComment(item)"
            >
              <v-icon small>
                mdi-delete
              </v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </div>
    <has-paid-dialog
      v-model="hasPaidDialogShowIt"
      :data="hasPaidDialogData"
    />
    <edit-payment-dialog
      v-model="editPaymentDialogShowIt"
      :data="editPaymentDialogData"
    />
  </div>
</template>

<script>
  import EditPaymentDialog from './components/EditPaymentDialog.vue'
  import HasPaidDialog from './components/HasPaidDialog.vue'
  import ChipSingulis from './components/ChipSingulis.vue'
  import ChipOmnibus from './components/ChipOmnibus.vue'

  export default {
    components: { HasPaidDialog, EditPaymentDialog, ChipSingulis, ChipOmnibus },
    data: () => ({
      search: '',
      hasPaidDialogShowIt: false,
      hasPaidDialogData: null,
      editPaymentDialogShowIt: false,
      editPaymentDialogData: null,
      isLoading: true,
      tableView: 'class',
      data: {},
      headers: [
        {
          text: 'Participant',
          align: 'start',
          value: 'participant',
        },
        {
          text: 'Etablissement',
          align: 'center',
          sortable: false,
          value: 'schoolName',
        },
        {
          text: 'Nb Classes',
          align: 'center',
          sortable: false,
          value: 'nbClasses',
        },
        {
          text: 'Nb Elèves',
          align: 'center',
          sortable: false,
          value: 'nbStudents',
        },
        {
          text: 'Singulis',
          align: 'center',
          sortable: false,
          value: 'singulis',
          __classView: true,
        },
        {
          text: 'Omnibus',
          align: 'center',
          sortable: false,
          value: 'omnibus',
          __classView: true,
        },
        {
          text: 'Mode Paiement',
          align: 'center',
          value: 'paymentMode',
          __billView: true,
        },
        {
          text: 'A Payé',
          align: 'center',
          value: 'hasPaid',
          __billView: true,
        },
        {
          text: 'Actions',
          align: 'right',
          sortable: false,
          value: 'actions',
        },
      ],
    }),
    computed: {
      filtered () {
        return this.headers.filter(one => {
          if (this.tableView === 'bill') {
            return !one.__classView
          } else {
            return !one.__billView
          }
        })
      },
      participants () {
        if (this.search.length < 3) {
          return this.data.list
        }
        return this.data.list.filter(one => {
          if (typeof this.search !== 'string') return true
          const search = this.search.toLocaleLowerCase()
          return one.__search.includes(search)
        })
      },
    },
    async mounted () {
      this.data = await this.$lco.admin.getParticipants()
      this.data.list.forEach(one => {
        one.__search = `${one.user.email}${one.user.username}${one.participant.fullName}${one.participant.school.name}`.toLocaleLowerCase()
      })
      this.isLoading = false
    },
    methods: {
      editComment (item) {
        console.log(item)
      },
      editHasPaid (item) {
        this.hasPaidDialogData = item
        this.hasPaidDialogShowIt = true
      },
      editPaymentMode (item) {
        this.editPaymentDialogData = item
        this.editPaymentDialogShowIt = true
      },
      searchFilter (value, search) {
        if (!value) return true
        if (typeof search !== 'string') return true
        const json = JSON.stringify(value).toLocaleLowerCase()
        const key = search.toLocaleLowerCase()
        console.log(json, key, json.includes(key))
        return json.includes(key)
      },
      viewSingulisWork (item) {
        const token = localStorage.getItem('jwt')
        const url = this.$http.getApiUrl(`/participant/classes/work/${item.singulisWork.storagePath}?token=${token}`)
        window.open(url, '_blank')
      },
      viewOmnibusWork (item) {
        const token = localStorage.getItem('jwt')
        const url = this.$http.getApiUrl(`/participant/classes/work/${item.omnibusWork.storagePath}?token=${token}`)
        window.open(url, '_blank')
      },
    },
  }
</script>
